import type { z } from 'zod'

import type { ApiRequest } from '~/types/ApiRequest'
import { requestAndParse } from '~/services/api/requestAndParse'

export const createDeleteOperation =
  <Arguments extends readonly unknown[], Path>(
    client: ApiRequest,
    parsePath: (...args: Arguments) => Path,
    successSchema: z.ZodType,
    buildUrl: (path: Path) => string
  ): ((...args: Arguments) => Promise<void>) =>
  async (...args: Arguments): Promise<void> => {
    await requestAndParse(client, successSchema, buildUrl(parsePath(...args)), {
      method: 'DELETE'
    })
  }
